import Signin from "@/components/signin/App";
import Home from "@/infrastructure/home/Home";
import { useIsLogin } from "@/openbaas";
import React from "react";

function HomePage() {
  const { isLogin } = useIsLogin();
  return (
    <div>
      {isLogin ? (
        <Home />
      ) : (
        <div className="w-11/12 max-w-md mx-auto">
          <Signin />
        </div>
      )}
    </div>
  );
}

export default HomePage;
